<template>
    <div class="table__heading">
        <v-icon
            size="20"
            :color="iconColor"
            class="mr-2"
        >
            <slot name="icon"></slot>
        </v-icon>
        <h1 class="table-title">
            <slot name="title"></slot>
        </h1>
    </div>
</template>

<script>
export default {
    name: "BaseTableHeading",
    props: {
        iconColor: {
            type: String,
            default: "primary lighten-1",
        },
    },
};
</script>

<style lang="scss" scoped>
.table__heading {
    display: flex;
    .table-title {
        font-size: 1.3em;
        font-weight: 500;
        line-height: 1.4;
        letter-spacing: 0.02em;
        color: #535c68;
    }
}
</style>
